<template>
	<div
		ref="scoreTable"
		class="score-table--wrapper"
	>
		<div
			class="score-table"
			:class="{'is-mobile': isMobileWebApp}"
		>
			<div class="head">
				<div class="row">
					<div class="cell" />
					<div
						v-for="(column, idx) in columns"
						:key="idx"
						class="cell"
					>
						{{ column.label }}
					</div>
				</div>
			</div>
			<div class="divider" />
			<div class="body">
				<template
					v-for="(row, idx) in board"
				>
					<div
						:key="`${idx}row`"
						class="row"
						:class="{highlight: (row.team.id === teams.teamHome.id || row.team.id === teams.teamGuest.id)}"
					>
						<div class="cell">
							{{ row.team.position }}
						</div>
						<div class="cell team-name">
							<img
								class="team-image"
								:src="getTeamImage(row.team.imageUrl)"
							>
							<a
								target="_blank"
								:href="teamUrl(row.team)"
							>
								{{ row.team.club.code }}
							</a>
						</div>
						<div
							v-for="(item, index) in row.stats"
							:key="index"
							class="cell"
						>
							{{ item.value }}
						</div>
					</div>
					<div
						:key="`${idx}divider`"
						class="divider"
					/>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import laroute from '@laroute';

export default {
	name:  'ScoreTable',
	props: {
		columns: {
			type:    Array,
			default: () => [],
		},
		teams: {
			type:    Object,
			default: () => {
			},
		},
		board: {
			type:    Array,
			default: () => [],
		},
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
	},
	methods: {
		getTeamImage(imageUrl) {
			return this.$Helpers ? this.$Helpers.getScaledImageUrl(imageUrl, 50) : imageUrl;
		},
		teamUrl(team) {
			return laroute.route('arena.team', {
				team: team?.id,
				slug: this.$Helpers.slugify(team?.name),
			});
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.score-table--wrapper {
	overflow-y: auto;
	height: 100%;

	.is-mobile & {
		overflow-y: initial;
	}
}

.score-table {
	@include text-sm-2;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
}

.head {
	display: flex;
	@include text-sm-2;
	font-weight: 500;

	.row {
		height: 40px;
		align-items: center;
		display: flex;
		width: 100%;
		padding-right: 1rem;
	}

	.cell {
		width: 10%;
		text-align: center;

		&:nth-child(1) {
			width: 15%;
		}

		&:nth-child(2) {
			width: 35%;
			text-align: left;
		}

		&:last-child {
			margin-left: 5px;
		}
	}
}

.divider {
	height: 1px;
	margin-right: 8px;
	margin-left: 8px;
	background: var(--color-grey-900);
}

.body {
	display: flex;
	flex-direction: column;
	height: 100%;

	.row {
		display: flex;
		width: 100%;
		align-items: center;
		max-height: 104px;
		min-height: 48px;
		height: 100%;
		padding-right: 1rem;

		&:hover {
			background-color: var(--color-grey-950);
		}

		.cell {
			width: 10%;
			text-align: center;

			&:nth-child(1) {
				width: 15%;
			}

			&:nth-child(2) {
				width: 35%;
				font-weight: 600;
			}

			&:nth-child(n+3) {
				color: var(--color-grey-300);
			}

			&:last-child {
				margin-left: 5px;
			}
		}

	}
}

.team-image {
	width: 32px;
	height: auto;
	vertical-align: middle;
	margin-right: 1rem;
}

.team-name {
	display: flex;
	align-items: center;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	a {
		color: var(--color-white);
		@include text-sm-2;
		font-weight: 500;

		body.-t-light & {
			color: var(--color-black);
		}
	}
}
</style>
